import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { NoActivePlanModal } from './NoActivePlanModal'
import { NotMigratedCompanyModal } from './NotMigratedCompanyModal'
import { CompanyHasNoDatabaseModal } from './CompanyHasNoDatabaseModal'
import { IpNotAllowedModal } from './IpNotAllowedModal'
import { OverDriverLimitModal } from './OverDriverLimitModal'
import { PaymentRequiredModal } from './PaymentRequiredModal'

export const GlobalErrorHandler = () => {
  const [errorCode, setErrorCode] = React.useState<string | null>(null)
  const [errorData, setErrorData] = React.useState<any>(null)
  const location = useLocation()

  React.useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      setErrorCode(detail.errorCode)
      setErrorData(detail.data ?? null)
    }
    window.addEventListener('globalApiError', handler)
    return () => window.removeEventListener('globalApiError', handler)
  }, [])

  // The payment-required modal has no explicit dismiss, so clear it on navigation —
  // otherwise it stays pinned on top after the user uses the (now-interactive) sidebar
  // to leave the unpaid company. If the destination is still unpaid, the next failing
  // request re-arms it.
  React.useEffect(() => {
    setErrorCode(null)
    setErrorData(null)
  }, [location.pathname])

  if (errorCode === 'PAYMENT_REQUIRED') {
    return <PaymentRequiredModal data={errorData} />
  }

  if (errorCode === 'OVER_DRIVER_LIMIT') {
    return (
      <OverDriverLimitModal
        data={errorData}
        onClose={() => setErrorCode(null)}
      />
    )
  }

  if (errorCode === 'NO_ACTIVE_PLAN') {
    return (
      <NoActivePlanModal
        data={errorData}
        onClose={() => setErrorCode(null)}
      />
    )
  }

  if (errorCode === 'IP_NOT_ALLOWED') {
    return (
      <IpNotAllowedModal
        companyId={errorData?.companyId ?? null}
        ip={errorData?.ip ?? null}
        onCompanyChange={() => setErrorCode(null)}
      />
    )
  }

  if (errorCode === 'COMPANY_HAS_NO_DATABASE') {
    return (
      <CompanyHasNoDatabaseModal
        companyId={errorData?.companyId ?? null}
        onCompanyChange={() => setErrorCode(null)}
      />
    )
  }

  if (errorCode === 'NOT_MIGRATED_COMPANY') {
    return (
      <NotMigratedCompanyModal
        companyId={errorData?.companyId ?? null}
        onCompanyChange={() => setErrorCode(null)}
      />
    )
  }
  return null
}
